
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tentang-perusahaan/siaran-pers",
      function () {
        return require("private-next-pages/tentang-perusahaan/siaran-pers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tentang-perusahaan/siaran-pers"])
      });
    }
  